var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgS(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4905 9.0175C20.9033 9.42107 21.2312 9.90303 21.4551 10.4351C21.679 10.9671 21.7943 11.5386 21.7943 12.1158C21.7943 12.6931 21.679 13.2645 21.4551 13.7966C21.2312 14.3286 20.9033 14.8106 20.4905 15.2141C19.8937 15.7826 19.1271 16.1398 18.3079 16.2312C17.4888 16.3225 16.6623 16.1428 15.955 15.7197L12.2572 13.7697C12.2431 14.9443 12.6361 16.0876 13.3694 17.0053C14.0525 17.8065 14.9416 18.4059 15.9405 18.7386L16.215 18.8252V20.963H6.3928V18.9119L6.68168 18.8252C7.67015 18.5026 8.55003 17.9127 9.2239 17.1208C9.974 16.1994 10.3777 15.0444 10.365 13.8564L6.6528 15.8208C5.94766 16.2374 5.12568 16.412 4.31208 16.3182C3.49848 16.2243 2.73788 15.867 2.14614 15.3008C1.33855 14.4866 0.886655 13.3854 0.889478 12.2386C0.886867 11.0833 1.33816 9.97324 2.14614 9.1475L11.2894 0.95752L20.4905 9.0175Z",
    fill: "#000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS);
export default __webpack_public_path__ + "static/media/s.7d67b1752c7971c797c20cce129a064f.svg";
export { ForwardRef as ReactComponent };